import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { NAVEGACION } from '../../utilidades/interior.static';
import { AutorizacionService } from 'src/app/compartido/autorizacion/autorizacion.service';

@Component({
  selector: 'interior-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidenavComponent implements OnInit {
  /* Navegación */
  protected readonly NAVEGACION = NAVEGACION;

  /* Mostrar categorías */
  protected mostrarCategoria: WritableSignal<Map<string, boolean>> = signal(new Map());

  constructor(
    private readonly _cdr: ChangeDetectorRef,
    private readonly autorizacionService: AutorizacionService,
  ) {}

  ngOnInit(): void {
    this.poblarMostrarCategoria$();
  }

  /**
   * Puebla si la categorías debe mostrarse.
   * @author Juan Corral
   */
  protected async poblarMostrarCategoria$(): Promise<void> {
    loopCategoria: for (const categoria of this.NAVEGACION) {
      for (const pagina of categoria.paginas) {
        const autorizado = await this.autorizacionService.tieneAutorizacion$(pagina.autorizacion);
        if (autorizado) {
          this.mostrarCategoria.update((mostrar) => {
            mostrar.set(categoria.nombre, true);
            return mostrar;
          });
          continue loopCategoria;
        }
      }
      this.mostrarCategoria.update((mostrar) => {
        mostrar.set(categoria.nombre, false);
        return mostrar;
      });
    }
    this._cdr.markForCheck();
  }
}
